import { CallState, DisruptionOffer } from "@hopper-b2b/types";
import { actions, actionTypes } from "../actions";

export interface IFlightDisruptionState {
  disruptionOffersCallState: CallState;
  disruptionOffers?: DisruptionOffer[];
  selectedScheduleChangeOffer?: DisruptionOffer;
  selectedMissedConnectionOffer?: DisruptionOffer;
}

export const initialState: IFlightDisruptionState = {
  disruptionOffersCallState: CallState.NotCalled,
  disruptionOffers: undefined,
  selectedScheduleChangeOffer: undefined,
  selectedMissedConnectionOffer: undefined,
};

export function reducer(
  state: IFlightDisruptionState = initialState,
  action: actions.FlightDisruptionActions
): IFlightDisruptionState {
  switch (action.type) {
    case actionTypes.FETCH_DISRUPTION_OFFERS:
      return {
        ...initialState,
        disruptionOffersCallState: CallState.InProcess,
      };

    case actionTypes.SET_DISRUPTION_OFFERS:
      return {
        ...state,
        disruptionOffers: action.offers,
        disruptionOffersCallState: CallState.Success,
        selectedScheduleChangeOffer: undefined,
        selectedMissedConnectionOffer: undefined,
      };

    case actionTypes.SET_DISRUPTION_OFFERS_FAILED:
      return {
        ...state,
        disruptionOffersCallState: CallState.Failed,
      };

    case actionTypes.SET_SELECTED_SCHEDULE_CHANGE_OFFER:
      return {
        ...state,
        selectedScheduleChangeOffer: action.offer,
      };

    case actionTypes.SET_SELECTED_MISSED_CONNECTION_OFFER:
      return {
        ...state,
        selectedMissedConnectionOffer: action.offer,
      };

    default:
      return state;
  }
}

export * from "./selectors";
